<script>
import { Overlay } from '../../'

export default {
    name: 'SupportResistanceTable',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'TradingCandle',
                version: '1.0.0',
                desc: 'Support Resistance Table - Rolling high/low support and resistance for the current chart timeframe',
                preset: {
                    name: 'Support Resistance Table',
                    side: 'onchart',
                    settings: {
                        tableX: 10,
                        tableY: 200,
                        fontSize: 12,
                        bgColor: 'rgba(0, 0, 0, 0.7)',
                        textColor: '#ffffff',
                        headerColor: '#e54150',
                        borderColor: '#444444',
                        showTable: true,
                        showSupport: true,
                        showResistance: true
                    }
                }
            }
        },
        calc() {return {
            props:{length:{def:20,text:'Support / resistance lookback',min:1,step:1}},
            update:`return [lowest(low,length)[0],highest(high,length)[0]];`
        }},
        init() {},
        draw(ctx) {
            if (!this.show_table) return

            const layout = this.$props.layout

            // Calculated current-chart levels; no illustrative price data.
            const latest=this.$props.data.at(-1);
            const format=value=>Number.isFinite(value)?value.toLocaleString(undefined,{maximumFractionDigits:8}):'Waiting';
            const srData = {[String(this.tf||'Chart')]:{support:format(latest?.[1]),resistance:format(latest?.[2])}};
            const timeframes = Object.keys(srData).sort()

            // Table dimensions
            const colWidths = [80, 70, 70] // Timeframe, Support, Resistance
            const rowHeight = this.font_size + 8
            const headerHeight = rowHeight + 4
            const tableWidth = colWidths.reduce((a, b) => a + b, 0) + 10
            const tableHeight = headerHeight + (timeframes.length * rowHeight) + 10

            // Position at bottom-right of chart
            const chartWidth = layout.width || 800
            const chartHeight = layout.height || 400
            const x = Math.max(0,Math.min(this.table_x,chartWidth-tableWidth))
            const y = Math.max(0,Math.min(this.table_y,chartHeight-tableHeight))

            // Draw background
            ctx.fillStyle = this.bg_color
            ctx.fillRect(x, y, tableWidth, tableHeight)
            ctx.strokeStyle = this.border_color
            ctx.lineWidth = 1
            ctx.strokeRect(x, y, tableWidth, tableHeight)

            // Draw header
            ctx.fillStyle = this.header_color
            ctx.fillRect(x, y, tableWidth, headerHeight)
            ctx.strokeStyle = this.border_color
            ctx.strokeRect(x, y, tableWidth, headerHeight)

            // Header text
            ctx.fillStyle = this.text_color
            ctx.font = `bold ${this.font_size}px Arial`
            ctx.textAlign = 'center'
            ctx.textBaseline = 'middle'

            const headers = ['TF', 'Support', 'Resistance']
            let headerX = x + 5
            headers.forEach((header, i) => {
                ctx.fillText(header, headerX + colWidths[i] / 2, y + headerHeight / 2)
                headerX += colWidths[i]
            })

            // Draw rows for each timeframe
            ctx.font = `${this.font_size}px Arial`
            let rowY = y + headerHeight

            timeframes.forEach(tf => {
                const tfData = srData[tf]
                const support = this.show_support ? (tfData.support || '-') : '-'
                const resistance = this.show_resistance ? (tfData.resistance || '-') : '-'
                const values = [tf, support, resistance]

                // Draw row background (alternating)
                const rowIdx = timeframes.indexOf(tf)
                if (rowIdx % 2 === 0) {
                    ctx.fillStyle = 'rgba(255, 255, 255, 0.05)'
                    ctx.fillRect(x + 1, rowY, tableWidth - 2, rowHeight)
                }

                // Draw row values
                ctx.fillStyle = this.text_color
                let cellX = x + 5
                values.forEach((val, i) => {
                    ctx.fillText(val, cellX + colWidths[i] / 2, rowY + rowHeight / 2)
                    cellX += colWidths[i]
                })

                // Draw row separator
                ctx.strokeStyle = this.border_color
                ctx.beginPath()
                ctx.moveTo(x, rowY + rowHeight)
                ctx.lineTo(x + tableWidth, rowY + rowHeight)
                ctx.stroke()

                rowY += rowHeight
            })
        },
        use_for() { return ['SupportResistanceTable'] },
        legend() {
            return []
        }
    },
    computed: {
        sett() {
            return this.$props.settings
        },
        table_x() {
            return this.sett.tableX ?? 10
        },
        table_y() {
            return this.sett.tableY ?? 200
        },
        font_size() {
            return this.sett.fontSize || 12
        },
        bg_color() {
            return this.sett.bgColor || 'rgba(0, 0, 0, 0.7)'
        },
        text_color() {
            return this.sett.textColor || '#ffffff'
        },
        header_color() {
            return this.sett.headerColor || '#e54150'
        },
        border_color() {
            return this.sett.borderColor || '#444444'
        },
        show_table() {
            return this.sett.showTable !== false
        },
        show_support() {
            return this.sett.showSupport !== false
        },
        show_resistance() {
            return this.sett.showResistance !== false
        }
    }
}
</script>
